/**
 * Event Bus cho việc quản lý sự kiện global trong app
 * Sử dụng để thông báo giữa các components/stores
 */

class EventBus {
  constructor() {
    this.listeners = {};
  }

  /**
   * Đăng ký lắng nghe sự kiện
   * @param {string} event - Tên sự kiện
   * @param {function} callback - Hàm callback
   */
  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);

    // Return unsubscribe function
    return () => {
      this.off(event, callback);
    };
  }

  /**
   * Hủy đăng ký lắng nghe sự kiện
   * @param {string} event - Tên sự kiện
   * @param {function} callback - Hàm callback
   */
  off(event, callback) {
    if (!this.listeners[event]) return;

    this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
  }

  /**
   * Phát sự kiện
   * @param {string} event - Tên sự kiện
   * @param {*} data - Dữ liệu đi kèm
   */
  emit(event, data) {
    if (!this.listeners[event]) return;

    this.listeners[event].forEach(callback => {
      try {
        callback(data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Error in event listener for ${event}:`, error);
      }
    });
  }

  /**
   * Xóa tất cả listeners cho một sự kiện
   * @param {string} event - Tên sự kiện
   */
  clear(event) {
    if (event) {
      delete this.listeners[event];
    } else {
      this.listeners = {};
    }
  }
}

export const eventBus = new EventBus();

// Các constants cho sự kiện
export const EVENTS = {
  USER_LOGOUT: 'USER_LOGOUT',
  USER_LOGIN: 'USER_LOGIN',
  FEATURES_UPDATED: 'FEATURES_UPDATED',
  OPEN_FEEDBACK_POPUP: 'OPEN_FEEDBACK_POPUP',
};

export default eventBus;
